import styled, { css } from '@xstyled/styled-components';
import { jumpAnimation } from '~/ui/animation';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

const selectorVisualFeedback = (s: TrainingState) =>
  select(s, 'visualFeedback');

export const IncorrectBadge = styled.divBox`
  z-index: 4;
  ${p => {
    const { visualFeedback } = useTrainingStore(selectorVisualFeedback);
    const sec = visualFeedback ? '0.7s' : '0s';

    return css`
      &:after {
        content: '!';
        color: white;
        position: absolute;
        width: 28px;
        height: 28px;
        border-radius: 14px;
        background-color: redDark;
        top: -14px;
        right: -14px;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: ${jumpAnimation('0px', '5px', '0px')} ${sec} linear infinite;
      }
    `;
  }}
`;
